<template>
  <v-layout align-center justify-center row fill-height>
    <v-flex xs12 sm8 md4>
      <v-card class="elevation-12">
        <v-toolbar dark color="info" class="darken-3">
          <v-toolbar-title>Login form</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <v-form @submit.prevent="checkLogin" id="loginForm">
            <v-text-field prepend-icon="person" id="userLogin" v-model="userLogin" placeholder="login"></v-text-field>
            <v-text-field prepend-icon="lock" id="userPassword" v-model="userPassword" placeholder="password" type="password"></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="refresh()">
            Hard Refresh
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn form="loginForm" type="submit" color="info" class="darken-3">Login</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>

    <AppMainDialog :open="dialogOpen" :message="dialogMessage" @closedialog="dialogOpen = false"></AppMainDialog>
  </v-layout>
</template>

<script>
  import AppMainDialog from '@/components/AppMainDialog'

  export default {
    components: { AppMainDialog },
    data () {
      return {
        userLogin: '',
        userPassword: '',
        dialogMessage: '',
        dialogOpen: false
      }
    },
    methods: {
      checkLogin () {
        let onFulfilled = (defs) => {
          if (defs.access_token) {
            this.$store.dispatch('logIn').then(() => {
              localStorage.setItem('oauthToken', defs.access_token)
              localStorage.setItem('oauthTokenRefresh', defs.refresh_token)

              this.$axios.defaults.headers.common['Authorization'] = 'Bearer ' + defs.access_token

              this.$dfsUserAPI.getCurrentUser().then(result => {
                localStorage.setItem('loggedUserEmail', result.email)
                localStorage.setItem('currentUser', JSON.stringify(result))

                this.$store.dispatch('setLoggedUserEmail', result.email)
                this.$store.dispatch('setCurrentUser', result)

                this.$dfsUserAPI.getCurrentUserRoles().then(result => {
                  let arr = []

                  result.forEach(item => {
                    arr.push(item.name)
                  })

                  localStorage.setItem('currentUserRoles', JSON.stringify(arr))

                  this.$store.dispatch('setCurrentUserRoles', arr)
                  this.$store.dispatch('setAppIsLoaded', true)

                  this.access = arr
                })
              }, error => {
                let handle = error // eslint-disable-line
              })

              this.$router.push({
                'name': 'Home'
              })
            })
          }
        }

        let onRejected = (defs) => {
          this.dialogMessage = 'Invalid credentialls'
          this.dialogOpen = true
        }

        let credentials = {
          userLogin: this.userLogin,
          userPassword: this.userPassword
        }

        let result = this.$dfsUserAPI.auth(credentials)

        result.then(onFulfilled, onRejected)
      },
      refresh () {
        location.reload(true)
      }
    },
    created () {
      this.$on('dialog-close', () => {
        this.dialogOpen = false
      })

      if (this.$store.getters.logInStatus === true) {
        this.$router.push({
          name: 'Home'
        })
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// Login.vue?0325f4d3